/**
 * Czech domestic accounts: mod11 and the ČNB bank code list; always convertible to IBAN.
 * @module banking/schemes/cz
 */

import { czechAccountToIBAN } from '../conversion';
import { validateCzechBankAccount } from '../validation';
import { BankAccountScheme, type BankAccountSchemeDefinition } from './bank-account-scheme';
import {
  checkDomesticAccount,
  formatDomesticNumber,
  parseDomesticAccount
} from './domestic-account';
import { bicErrors, normalizeBic } from './scheme-helpers';

const COUNTRY = 'CZ';

export const czScheme: BankAccountSchemeDefinition = {
  scheme: BankAccountScheme.CZ,

  validate(account) {
    const { errors, parts } = checkDomesticAccount(account, COUNTRY);
    if (parts) {
      errors.push(
        ...validateCzechBankAccount(`${formatDomesticNumber(parts)}/${parts.bankCode}`).errors
      );
    }
    errors.push(...bicErrors(account.bic));

    return { valid: errors.length === 0, errors };
  },

  normalize(account) {
    const parts = parseDomesticAccount(account);
    if (!parts) return null;

    return {
      scheme: BankAccountScheme.CZ,
      countryCode: COUNTRY,
      iban: null,
      bankIdentifier: parts.bankCode,
      accountNumber: formatDomesticNumber(parts),
      bic: normalizeBic(account.bic)
    };
  },

  toIban(account) {
    const parts = parseDomesticAccount(account);
    if (!parts) return null;

    return czechAccountToIBAN(formatDomesticNumber(parts), parts.bankCode)?.iban ?? null;
  }
};
